
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic02On as ObiHydraulic02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-02-on.js';
 
 
 

 
 export const ObiHydraulic02On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-02-on',
   elementClass: ObiHydraulic02OnElement,
   events: {
     
   }
  });
 
 